/**
 * @generated SignedSource<<d6b059a7089fac3e37f9e049adc5e251>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addressLine1"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addressLine2"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addressLine3"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "billingPermitted"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "city"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveFrom"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveTo"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "legalContractLineOfServiceId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "npi"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "phoneNumber"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "postalCode"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "remittanceAddressId"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "state"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tin"
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BillingGroupMutationGroup",
    "kind": "LinkedField",
    "name": "billingGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "addressLine1",
                "variableName": "addressLine1"
              },
              {
                "kind": "Variable",
                "name": "addressLine2",
                "variableName": "addressLine2"
              },
              {
                "kind": "Variable",
                "name": "addressLine3",
                "variableName": "addressLine3"
              },
              {
                "kind": "Variable",
                "name": "billingPermitted",
                "variableName": "billingPermitted"
              },
              {
                "kind": "Variable",
                "name": "city",
                "variableName": "city"
              },
              {
                "kind": "Variable",
                "name": "effectiveFrom",
                "variableName": "effectiveFrom"
              },
              {
                "kind": "Variable",
                "name": "effectiveTo",
                "variableName": "effectiveTo"
              },
              {
                "kind": "Variable",
                "name": "legalContractLineOfServiceId",
                "variableName": "legalContractLineOfServiceId"
              },
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "name"
              },
              {
                "kind": "Variable",
                "name": "npi",
                "variableName": "npi"
              },
              {
                "kind": "Variable",
                "name": "phoneNumber",
                "variableName": "phoneNumber"
              },
              {
                "kind": "Variable",
                "name": "postalCode",
                "variableName": "postalCode"
              },
              {
                "kind": "Variable",
                "name": "remittanceAddressId",
                "variableName": "remittanceAddressId"
              },
              {
                "kind": "Variable",
                "name": "state",
                "variableName": "state"
              },
              {
                "kind": "Variable",
                "name": "tin",
                "variableName": "tin"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "RemittanceAddressModifyPayload",
        "kind": "LinkedField",
        "name": "modifyRemittanceAddress",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RemittanceAddress",
            "kind": "LinkedField",
            "name": "remittanceAddress",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LegalContractLineOfService",
                "kind": "LinkedField",
                "name": "lineOfService",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LineOfService",
                    "kind": "LinkedField",
                    "name": "lineOfService",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "npi",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tin",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billingPermitted",
                "storageKey": null
              },
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "addressLine1",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "addressLine2",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "addressLine3",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postalCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "effectiveFrom",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "effectiveTo",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditRemittanceAddressModalMutation",
    "selections": (v17/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v12/*: any*/),
      (v7/*: any*/),
      (v9/*: any*/),
      (v14/*: any*/),
      (v3/*: any*/),
      (v8/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v13/*: any*/),
      (v11/*: any*/),
      (v10/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditRemittanceAddressModalMutation",
    "selections": (v17/*: any*/)
  },
  "params": {
    "cacheID": "38c241e1d5459846ef1c833614a7db74",
    "id": null,
    "metadata": {},
    "name": "EditRemittanceAddressModalMutation",
    "operationKind": "mutation",
    "text": "mutation EditRemittanceAddressModalMutation(\n  $remittanceAddressId: ID!\n  $legalContractLineOfServiceId: ID!\n  $npi: String!\n  $tin: String!\n  $billingPermitted: Boolean!\n  $name: String!\n  $addressLine1: String!\n  $addressLine2: String!\n  $addressLine3: String!\n  $city: String!\n  $state: String!\n  $postalCode: String!\n  $phoneNumber: String!\n  $effectiveFrom: DateOnly!\n  $effectiveTo: DateOnly!\n) {\n  billingGroup {\n    modifyRemittanceAddress(input: {remittanceAddressId: $remittanceAddressId, legalContractLineOfServiceId: $legalContractLineOfServiceId, npi: $npi, tin: $tin, billingPermitted: $billingPermitted, name: $name, addressLine1: $addressLine1, addressLine2: $addressLine2, addressLine3: $addressLine3, city: $city, state: $state, postalCode: $postalCode, phoneNumber: $phoneNumber, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {\n      remittanceAddress {\n        id\n        lineOfService {\n          id\n          lineOfService {\n            name\n            id\n          }\n        }\n        npi\n        tin\n        billingPermitted\n        name\n        addressLine1\n        addressLine2\n        addressLine3\n        city\n        state\n        postalCode\n        phoneNumber\n        effectiveFrom\n        effectiveTo\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "c2aec07c1da58b15899f7ecd609e2c18";

export default node;
